<template>
    <TeaseItems :items="contents" :limit="currentLimit" :teaser-slot-size="0">
        <template v-slot:default="{ displayItems, moreItems, showMore }">
            <div>
                <ResponsiveGrid
                    :columns="{ default: 2, xs: 3, sm: 4, md: 5, xl: 6 }"
                    :rows="rows"
                    :gap="{ default: '10px', sm: '20px' }"
                    @preparedCells="limit = $event"
                >
                    <slot :contents="paginatedContents">
                        <a
                            v-for="content of paginatedContents"
                            :key="content.id"
                            :href="content.media_url"
                            class="anonymous"
                            target="_blank"
                            title="Vis opslag"
                        >
                            <ContentCard :class="contentClass" :content="content" />
                        </a>
                    </slot>
                </ResponsiveGrid>

                <div v-if="hasMoreItems" class="text-center mt-3 sm:mt-5">
                    <button
                        type="button"
                        class="px-3 py-2 rounded-full text-xs"
                        style="background: var(--magic-color); color: white;"
                        @click="loadMore"
                    >
                        Indlæs flere
                    </button>
                </div>
            </div>
        </template>
    </TeaseItems>
</template>

<style lang="less" type="text/less"></style>

<script type="text/babel">
import ContentCard from 'dashboard-js/components/contents/ContentCard'
import ResponsiveGrid from 'dashboard-js/components/ResponsiveGrid'
import TeaseItems from 'dashboard-js/components/TeaseItems'

export default {
    components: { ContentCard, ResponsiveGrid, TeaseItems },

    directives: {},

    mixins: [],

    props: ['contents', 'rows', 'contentClass', 'color'],

    data() {
        return {
            limit: null,
            currentPage: 1,
            itemsPerPage: 10
        }
    },

    computed: {
        currentLimit() {
            return this.limit !== null ? this.limit : 1000
        },
        hasMoreItems() {
            return this.contents.length > this.currentPage * this.itemsPerPage
        },
        paginatedContents() {
            return this.contents.slice(0, this.currentPage * this.itemsPerPage)
        },
    },

    methods: {
        loadMore() {
            this.currentPage++
        }
    }
}
</script>